import React from 'react'

export default function Columns2({ children }) {
  return <div className="tw-grid tw-grid-cols-2 tw-gap-4">{children}</div>
}
